var C2W_EVENT_TYPES;

(function (C2W_EVENT_TYPES) {
  C2W_EVENT_TYPES["UPDATE_BALANCE"] = "balance_update";
  C2W_EVENT_TYPES["WALLET_UPDATE"] = "wallet_update";
  C2W_EVENT_TYPES["UPDATE_COMPARISON_BASKET"] = "comparison_basket_update";
  C2W_EVENT_TYPES["UPDATE_TRADE_OFF_VEHICLE"] = "active_trade_off_update";
  C2W_EVENT_TYPES["UPDATE_PERSONAL_TRADE_OFF_VEHICLE"] = "active_personal_trade_off_update";
  C2W_EVENT_TYPES["UPDATE_VEHICLE_STATE"] = "vehicle_state_update";
  C2W_EVENT_TYPES["UPDATE_TOKEN_LIST"] = "token_list_update";
  C2W_EVENT_TYPES["UPDATE_TOKENS"] = "tokens_update";
  C2W_EVENT_TYPES["WGBOB_COEFFICIENTS_UPDATE"] = "wgbob_coefficients_update";
  C2W_EVENT_TYPES["ON_REACTIVE_COMMUNICATION_CHANNEL_MESSAGE"] = "on_reactive_communication_channel_message";
  C2W_EVENT_TYPES["ON_REACTIVE_COMMUNICATION_SUBSCRIPTION_CLOSED"] = "on_reactive_communication_subscription_closed";
})(C2W_EVENT_TYPES || (C2W_EVENT_TYPES = {}));var VEHICLE_STATE;

(function (VEHICLE_STATE) {
  VEHICLE_STATE["DAMAGED"] = "damaged";
  VEHICLE_STATE["EXPLODED"] = "exploded";
  VEHICLE_STATE["DESTROYED"] = "destroyed";
  VEHICLE_STATE["UNDAMAGED"] = "undamaged";
  VEHICLE_STATE["BATTLE"] = "battle";
  VEHICLE_STATE["IN_PREBATTLE"] = "inPrebattle";
  VEHICLE_STATE["LOCKED"] = "locked";
  VEHICLE_STATE["CREW_NOT_FULL"] = "crewNotFull";
  VEHICLE_STATE["AMMO_NOT_FULL"] = "ammoNotFull";
  VEHICLE_STATE["AMMO_NOT_FULL_EVENTS"] = "ammoNotFullEvents";
  VEHICLE_STATE["SERVER_RESTRICTION"] = "serverRestriction";
  VEHICLE_STATE["RENTAL_IS_OVER"] = "rentalIsOver";
  VEHICLE_STATE["IGR_RENTAL_IS_OVER"] = "igrRentalIsOver";
  VEHICLE_STATE["IN_PREMIUM_IGR_ONLY"] = "inPremiumIgrOnly";
  VEHICLE_STATE["GROUP_IS_NOT_READY"] = "group_is_not_ready";
  VEHICLE_STATE["NOT_PRESENT"] = "notpresent";
  VEHICLE_STATE["UNAVAILABLE"] = "unavailable";
  VEHICLE_STATE["UNSUITABLE_TO_QUEUE"] = "unsuitableToQueue";
  VEHICLE_STATE["UNSUITABLE_TO_UNIT"] = "unsuitableToUnit";
  VEHICLE_STATE["DEAL_IS_OVER"] = "dealIsOver";
  VEHICLE_STATE["ROTATION_GROUP_UNLOCKED"] = "rotationGroupUnlocked";
  VEHICLE_STATE["ROTATION_GROUP_LOCKED"] = "rotationGroupLocked";
  VEHICLE_STATE["RENTABLE"] = "rentable";
  VEHICLE_STATE["RENTABLE_AGAIN"] = "rentableAgain";
})(VEHICLE_STATE || (VEHICLE_STATE = {}));

var VEHICLE_STATE_LEVEL;

(function (VEHICLE_STATE_LEVEL) {
  VEHICLE_STATE_LEVEL["CRITICAL"] = "critical";
  VEHICLE_STATE_LEVEL["INFO"] = "info";
  VEHICLE_STATE_LEVEL["WARNING"] = "warning";
  VEHICLE_STATE_LEVEL["RENTED"] = "rented";
  VEHICLE_STATE_LEVEL["RENTABLE"] = "rentableBlub";
})(VEHICLE_STATE_LEVEL || (VEHICLE_STATE_LEVEL = {}));var handlerMap = {};
var reactiveHandlerMap = {};
var addWOTClientListener = function addWOTClientListener(type, handler) {
  if (!handlerMap[type]) {
    handlerMap[type] = [];
  }

  if (!handlerMap[type].includes(handler)) {
    handlerMap[type].push(handler);
  }
};
var removeWOTClientListener = function removeWOTClientListener(type, handler) {
  var listeners = handlerMap[type];

  if (listeners) {
    listeners = listeners.filter(function (callback) {
      return callback !== handler;
    });

    if (listeners.length) {
      handlerMap[type] = listeners;
    } else {
      delete handlerMap[type];
    }
  }
};
var addWOTReactiveListener = function addWOTReactiveListener(channel, handler) {
  if (!reactiveHandlerMap[channel]) {
    reactiveHandlerMap[channel] = [];
  }

  if (!reactiveHandlerMap[channel].includes(handler)) {
    reactiveHandlerMap[channel].push(handler);
  }
};
var removeWOTReactiveListener = function removeWOTReactiveListener(channel, handler) {
  var listeners = reactiveHandlerMap[channel];

  if (listeners) {
    listeners = listeners.filter(function (callback) {
      return callback !== handler;
    });

    if (listeners.length) {
      reactiveHandlerMap[channel] = listeners;
    } else {
      delete reactiveHandlerMap[channel];
    }
  }
};

window.WoTClientEventHandler = function (callbackString) {
  var callbackData;

  try {
    callbackData = JSON.parse(callbackString);

    if (window.__C2W_LOG_ON__) {
      console.groupCollapsed(">> C2W event:");
      console.log(JSON.stringify(callbackData, null, 4));
      console.groupEnd();
    }
  } catch (error) {
    if (window.__C2W_LOG_ON__) {
      console.groupCollapsed(">> C2W error, cannot parse event data");
      console.log(callbackString);
      console.groupEnd();
    }

    throw error;
  }

  var _callbackData = callbackData,
      type = _callbackData.type;

  if (handlerMap[type]) {
    handlerMap[type].forEach(function (handler) {
      return handler(callbackData);
    });
  }

  if (type === C2W_EVENT_TYPES.ON_REACTIVE_COMMUNICATION_CHANNEL_MESSAGE) {
    var reactiveData = callbackData;
    var channel = reactiveData.data.channel_name;

    if (reactiveHandlerMap[channel]) {
      reactiveHandlerMap[channel].forEach(function (handler) {
        return handler(reactiveData);
      });
    }
  }

  return callbackData;
};export{C2W_EVENT_TYPES,VEHICLE_STATE,VEHICLE_STATE_LEVEL,addWOTClientListener,addWOTReactiveListener,removeWOTClientListener,removeWOTReactiveListener};//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wotfe/client2web/dist/index.esm.js
// module id = 126
// module chunks = 16